import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

/**
 * Le message d'une nouvelle version. Il ne décide de rien : « Recharger » le ferme par son
 * action, que `AppUpdateService` traduit en rechargement ; « Plus tard » le ferme seulement.
 */
@Component({
  selector: 'app-new-version-notice',
  imports: [MatButtonModule, MatSnackBarModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './new-version-notice.html',
})
export class NewVersionNotice {
  private readonly snackBarRef = inject<MatSnackBarRef<NewVersionNotice>>(MatSnackBarRef);

  reload(): void {
    this.snackBarRef.dismissWithAction();
  }

  later(): void {
    this.snackBarRef.dismiss();
  }
}
